import type { ReactHTML, ReactSVG } from 'react';

type Props = {
  children: string;
  tagName?: keyof ReactHTML | keyof ReactSVG;
  className?: string;
};

export const DangerouslySetInnerHTML = ({
  children,
  tagName: TagName = 'span',
  ...rest
}: Props) => (
  <TagName
    {...rest}
    dangerouslySetInnerHTML={{
      __html: children,
    }}
  />
);
